import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard';
import RouteOverview from './components/Pages/RouteOverview/RouteOverview';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import { authAPI } from './config/auth-api';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [adminData, setAdminData] = useState(null);

  useEffect(() => {
    const verifyAndAuth = async () => {
      if (authAPI.isAuthenticated()) {
        const result = await authAPI.verify();
        if (result.success) {
          setIsAuthenticated(true);
          setAdminData(result.data);
        } else {
          authAPI.logout();
          setIsAuthenticated(false);
        }
      }
      setLoading(false);
    };

    verifyAndAuth();
  }, []);

  const handleLogin = async (email, password) => {
    const result = await authAPI.login(email, password);
    if (result.success) {
      setIsAuthenticated(true);
      setAdminData(result.data);
    }
    return result;
  };

  const handleLogout = () => {
    authAPI.logout();
    setIsAuthenticated(false);
  };

  if (loading) {
    return (
      <div className="app-loading-state" style={{ height: '100vh' }}>
        <div className="app-loading-spinner"></div>
        <p>Loading...</p>
      </div >
    );
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/login"
            element={
              isAuthenticated ?
                <Navigate to="/dashboard" replace /> :
                <Login onLogin={handleLogin} />
            }
          />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Dashboard onLogout={handleLogout} adminData={adminData} setAdminData={setAdminData} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/route-overview"
            element={<RouteOverview />}
          />

          <Route
            path="/"
            element={<Navigate to="/dashboard" replace />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;